import React from "react";
import * as S from "./gold-icon-component.style";
import { GoldIconProps } from "./gold-icon-component.types";
const GoldIcon: React.FC<GoldIconProps> = ({ icon }) => {
	return <S.GoldIconContainer>{icon}</S.GoldIconContainer>;
};

export default GoldIcon;
